import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Inventory")]), _c("div", {
    staticClass: "search-global-container"
  }, [_vm.canManage ? _c("div", {
    staticClass: "search-top-buttons"
  }, [false ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.toggleWordMap();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-map-marked mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" Show Map ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      loading: _vm.isExporting
    },
    on: {
      click: function click($event) {
        return _vm.openExportStockDrawer();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-file-export mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" Export ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openReconcileStocks();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-tasks mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" Reconciliation ")], 1), _vm.canManageDomesticTransfers && false ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openWarehouseStockTransfer();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-exchange-alt mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" Entire warehouse transfer ")], 1) : _vm._e(), _vm.canManageDomesticTransfers ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openStockTransfersList();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-exchange-alt mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" Domestic transfers ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.stockDetails(null, false);
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" New stock without PO ")], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      placeholder: "Search for a name, domain ...",
      "append-icon": "fa-search",
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.wines,
      color: "white",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      solo: "",
      "item-text": "display_name",
      "item-value": "id_wine",
      label: _vm.isLoadingWines ? "Loading products ..." : "Filter by product",
      placeholder: "Type a product name, domain name, vintage...",
      filter: _vm.filterVAutocomplete,
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.id_wine,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "id_wine", $$v);
      },
      expression: "searchCriterias.id_wine"
    }
  }), _c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      type: "number",
      min: "1",
      prefix: "minStock (.btl) : ",
      placeholder: "Minimum stock available",
      clearable: "",
      filter: _vm.filterIntegerKey
    },
    on: {
      "click:clear": function clickClear($event) {
        _vm.options = {
          smoothScroll: false
        };
      },
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.minQuantityAvailable,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "minQuantityAvailable", $$v);
      },
      expression: "searchCriterias.minQuantityAvailable"
    }
  })], 1), _c("div", [_vm.$whitelabel.isAllowedToAccessPurchaseOrder ? _c(VSelect, {
    attrs: {
      items: _vm.stockTypesFilter,
      "item-value": "value",
      "item-text": "label",
      label: "Filter by stock type",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "type", $$v);
      },
      expression: "searchCriterias.type"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    attrs: {
      items: _vm.listWarehouses,
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: "",
      "item-text": "name",
      "item-value": "id_warehouse",
      label: _vm.isLoadingWarehouses ? "Loading warehouses ..." : "Filter by warehouse",
      color: "white",
      filter: _vm.filterVAutocomplete,
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.warehouseIds,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "warehouseIds", $$v);
      },
      expression: "searchCriterias.warehouseIds"
    }
  })], 1)]), _c("div", {
    staticClass: "search-other-fields",
    class: !_vm.isAdvancedFiltering && !_vm.isAdvancedFilterOpened ? "--collapsed" : "--opened"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.countries,
      label: "Filter by intended country",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: "",
      "item-text": "printable_name",
      "item-value": "id_country",
      filter: _vm.filterVAutocomplete,
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.intendedCountryIds,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "intendedCountryIds", $$v);
      },
      expression: "searchCriterias.intendedCountryIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listWarehouses,
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: "",
      "item-text": "name",
      "item-value": "id_warehouse",
      label: _vm.isLoadingWarehouses ? "Loading warehouses ..." : "Filter by consolidation for order",
      color: "white",
      filter: _vm.filterVAutocomplete,
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.warehouseDefaultDepartureIds,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "warehouseDefaultDepartureIds", $$v);
      },
      expression: "searchCriterias.warehouseDefaultDepartureIds"
    }
  })], 1), _c("div", [_c(VSelect, {
    attrs: {
      items: _vm.availableStockReservationTypes,
      "item-value": "id",
      "item-text": "name",
      label: "Filter by reservation type",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.reservationType,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "reservationType", $$v);
      },
      expression: "searchCriterias.reservationType"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.availableLowStockAlertTypes,
      "item-value": "id",
      "item-text": "name",
      label: "Filter by low stock alert",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.lowStockAlertType,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "lowStockAlertType", $$v);
      },
      expression: "searchCriterias.lowStockAlertType"
    }
  })], 1)]), _c("div", {
    staticClass: "search-pagination-index --with-collapse-trigger"
  }, [_c("div", [!_vm.isAdvancedFiltering && !_vm.isAdvancedFilterOpened ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click() {
        _vm.isAdvancedFilterOpened = true;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-filter mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" + filters ")], 1) : !_vm.isAdvancedFiltering ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click() {
        _vm.isAdvancedFilterOpened = false;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-filter mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" - filters ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.clearFilters
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-eraser mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" clear filters ")], 1)], 1), _c("index", {
    attrs: {
      currentPage: +_vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfStocks
    }
  })], 1)])]), _c(VDialog, {
    attrs: {
      fullscreen: ""
    },
    model: {
      value: _vm.dialogWorldMap,
      callback: function callback($$v) {
        _vm.dialogWorldMap = $$v;
      },
      expression: "dialogWorldMap"
    }
  }, [_c(VCard, [_c("WorldMap", {
    ref: "WorldMap",
    attrs: {
      markers: _vm.markers
    },
    on: {
      selectMarker: _vm.selectMarker
    }
  }), _c(VNavigationDrawer, {
    attrs: {
      width: "500px",
      app: "",
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer-header"
  }, [_c(VCard, {
    staticClass: "drawer-header-card"
  }, [_c(VCardTitle, {
    staticClass: "text-uppercase"
  }, [_vm._v("stocks")]), _c(VCardSubtitle, [_vm._v("located in " + _vm._s(_vm.selectedMarker.country))]), _c("i", {
    staticClass: "far fa-times-circle fa-times-circle-black",
    on: {
      click: function click($event) {
        _vm.drawer = false;
      }
    }
  })], 1)], 1), _c(VDivider), _c(VList, {
    staticClass: "drawer-content",
    attrs: {
      dense: "",
      nav: ""
    }
  }, _vm._l(_vm.selectedMarker.items, function (item) {
    return _c(VListItem, {
      key: item.id_stock
    }, [_c(VListItemContent, [_c(VCard, {
      attrs: {
        elevation: "2"
      }
    }, [_c(VCardSubtitle, {
      staticClass: "card-subtitle"
    }, [_vm._v(" " + _vm._s(item.reference_warehouse) + " - " + _vm._s(item.quantity) + " bottle "), item.quantity > 1 ? _c("span", [_vm._v("s")]) : _vm._e()]), item.stock_type.toUpperCase() === "CONSIGNMENT" ? _c(VCardText, [_vm._v(" Type: Direct Producer ")]) : item.stock_type.toUpperCase() === "STOCK" ? _c("div", {
      staticClass: "type-stock"
    }, [_c(VCardText, [_vm._v("Type: " + _vm._s(item.stock_type))]), _c(VCardText, [_vm._v("Warehouse: " + _vm._s(item.warehouse.name))])], 1) : _c(VCardText, [_vm._v("Type: " + _vm._s(item.stock_type.toUpperCase()))]), item.countries.length > 1 ? _c(VCardText, {
      staticClass: "font-italic"
    }, [_vm._v(" Shared among several locations ")]) : _vm._e()], 1)], 1)], 1);
  }), 1)], 1), _c("i", {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        _vm.dialogWorldMap = false;
      }
    }
  })], 1)], 1), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 cursor--pointer",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.datatable_items,
      "item-key": "id_stock",
      "items-per-page": +_vm.searchCriterias.paging.limits,
      loading: _vm.datatable_loading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.rowClicked
    },
    scopedSlots: _vm._u([{
      key: "item.reference_warehouse",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm.isEnvDevelopment ? _c("div", {
          staticClass: "text-italic text-smaller"
        }, [_vm._v(_vm._s(item.id_stock))]) : _vm._e(), _vm._v(" " + _vm._s(!String.isNullOrEmpty(item.reference_warehouse) ? item.reference_warehouse : item.accountancy_code) + " ")])];
      }
    }, {
      key: "item.vintage",
      fn: function fn(_ref2) {
        var _item$vintage;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s((_item$vintage = item.vintage) !== null && _item$vintage !== void 0 ? _item$vintage : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.qty",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", [_vm._v(_vm._s(item.qty) + " b.")]), item.hasLowStockAlert ? _c("div", {
          class: ["text-smaller", item.qty < item.lowStockAlertQuantity && "text-red", item.qty > item.lowStockAlertQuantity * 1.3 ? "text-green" : "text-orange"]
        }, [_vm._v(" Alert: " + _vm._s(item.lowStockAlertQuantity) + " b. ")]) : _vm._e()];
      }
    }, {
      key: "item.qty_committed",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", [_vm._v(" " + _vm._s(!!item.qty_committed ? item.qty_committed + " b." : _vm.emptyCellContent) + " ")]), !!item.qty_committed ? _c(VBtn, {
          staticClass: "dfwa-btn --small-3 secondary",
          attrs: {
            rounded: true
          },
          on: {
            click: function click($event) {
              return _vm.showCommittedDetails(item.id_stock);
            }
          }
        }, [_vm._v(" details ")]) : _vm._e()], 1)];
      }
    }, {
      key: "item.warehouse_name",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [item.warehouse_name ? _c("div", {
          staticClass: "text-smaller line-height-1_1"
        }, [_c("span", {
          staticClass: "text-italic"
        }, [_vm._v("Stored at")]), _c("br"), _vm._v(" " + _vm._s(item.warehouse_name) + " ")]) : _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v("Direct producer")])];
      }
    }, {
      key: "item.warehouse_departure_name",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [item.warehouse_departure_name ? _c("div", {
          staticClass: "text-smaller line-height-1_1"
        }, [_c("span", {
          staticClass: "text-italic"
        }, [_vm._v("Consolidation at")]), _c("br"), _vm._v(" " + _vm._s(item.warehouse_departure_name) + " ")]) : _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v("Direct producer")])];
      }
    }, {
      key: "item.reservation",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(" " + _vm._s(item.reservation ? item.reservation : _vm.emptyCellContent) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm.canManage ? _c("div", {
          staticClass: "table-actions"
        }, [_c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.stockDetails(item.id_stock);
            }
          }
        }, [_vm._v("Edit")]), _vm.canManage && item.status != _vm.stockStatus.filter(function (ss) {
          return ss.value === 2;
        })[0].label ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.showConfirmDelete(item.id_stock);
            }
          }
        }, [_vm._v(" Close ")]) : _vm._e()]) : _vm._e()])];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: +_vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      solo: "",
      items: _vm.pagingLimitsChoices,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: +_vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfStocks
    }
  })], 1)])]) : _vm._e(), _c("StockReconciliationDialog", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.stockReconciliationShown,
      callback: function callback($$v) {
        _vm.stockReconciliationShown = $$v;
      },
      expression: "stockReconciliationShown"
    }
  }), _c("StockCommittedDialog", {
    attrs: {
      idStock: _vm.stockCommittedIdStock
    },
    on: {
      close: _vm.closeCommittedDetails
    },
    model: {
      value: _vm.stockCommittedShown,
      callback: function callback($$v) {
        _vm.stockCommittedShown = $$v;
      },
      expression: "stockCommittedShown"
    }
  }), _vm.stockTransfersList.shown && _vm.canManageDomesticTransfers ? _c("StockTransferDomesticListModal", {
    ref: "stockTransfersList",
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      closed: function closed($event) {
        return _vm.closeStockTransfersList();
      }
    }
  }) : _vm._e(), _vm.warehouseStockTransfer.shown && _vm.canManageDomesticTransfers ? _c("WarehouseStockTransferModal", {
    ref: "warehouseStockTransfer",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      warehouses: _vm.listWarehouses
    },
    on: {
      entityCreated: function entityCreated($event) {
        return _vm.search();
      },
      closed: function closed($event) {
        return _vm.closeWarehouseStockTransfer();
      }
    }
  }) : _vm._e(), _vm.exportStockDrawer ? _c("StockExportDrawer", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      close: function close($event) {
        _vm.exportStockDrawer = false;
      }
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };